import type { AchievementDef } from '@/models/achievements';

export class AchievementToast {
  private container: HTMLElement;

  constructor(parent: HTMLElement) {
    this.container = document.createElement('div');
    this.container.className = 'achievement-toast';
    parent.appendChild(this.container);
  }

  show(achievement: AchievementDef): void {
    const item = document.createElement('div');
    item.className = 'achievement-toast-item';
    item.innerHTML = `
      <span class="achievement-toast-icon">${achievement.icon}</span>
      <div>
        <div class="achievement-toast-title">${achievement.name}</div>
        <div class="achievement-toast-reward">+${achievement.reward} 💎 gems</div>
      </div>
    `;

    this.container.appendChild(item);

    // Auto-dismiss after 3s
    setTimeout(() => {
      item.style.opacity = '0';
      item.style.transform = 'translateY(-8px)';
      setTimeout(() => {
        item.remove();
      }, 300);
    }, 3000);
  }

  destroy(): void {
    this.container.remove();
  }
}
